@let control = $control();
<unity-control-wrapper [control]="control" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  @let showControls = control && control.enabled;
  @let hideControlCss = showControls ? '' : 'hide-controls';
  <kendo-datepicker
    [class]="hideControlCss"
    [formControl]="control"
    [clearButton]="showControls"
    [readonly]="!showControls"
    [title]="control.value" />
</unity-control-wrapper>
